import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Menu, X, GraduationCap } from 'lucide-react';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);

  const languages = [
    { code: 'it', name: 'Italiano', flag: 'https://flagcdn.com/w40/it.png' },
    { code: 'en', name: 'English', flag: 'https://flagcdn.com/w40/gb.png' },
    { code: 'de', name: 'Deutsch', flag: 'https://flagcdn.com/w40/de.png' },
    { code: 'fr', name: 'Français', flag: 'https://flagcdn.com/w40/fr.png' },
    { code: 'es', name: 'Español', flag: 'https://flagcdn.com/w40/es.png' }
  ];

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo - clickable to Home */}
          <Link to="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
            <img 
              src="https://customer-assets.emergentagent.com/job_286e4964-f4c4-4bbc-b747-2b335ee2c3b0/artifacts/2w7jy3xv_OFFROAD%20ITALIA%20LOGO%202025.jpeg" 
              alt="Offroad Italia" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/events" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
              {t('nav.events')}
            </Link>
            <Link to="/gallery" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
              {t('nav.gallery')}
            </Link>
            <Link to="/corso-osmand" className="text-gray-700 hover:text-blue-600 font-medium transition-colors flex items-center">
              <GraduationCap size={18} className="mr-1" />
              {t('nav.corsoOsmand')}
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
              {t('nav.about')}
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
              {t('nav.contact')}
            </Link>
            
            {/* Language Switcher with Flag Images */}
            <div className="flex items-center space-x-1 border-l pl-4">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => changeLang(lang.code)}
                  title={lang.name}
                  className={`p-1 rounded transition-all ${
                    i18n.language === lang.code
                      ? 'ring-2 ring-blue-500 scale-110'
                      : 'opacity-70 hover:opacity-100 hover:scale-105'
                  }`}
                >
                  <img 
                    src={lang.flag} 
                    alt={lang.name}
                    className="w-8 h-6 object-cover rounded-sm"
                  />
                </button>
              ))}
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-700 hover:text-blue-600"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col space-y-3">
              <Link 
                to="/events" 
                className="text-gray-700 hover:text-blue-600 font-medium py-2"
                onClick={() => setIsOpen(false)}
              >
                {t('nav.events')}
              </Link>
              <Link 
                to="/gallery" 
                className="text-gray-700 hover:text-blue-600 font-medium py-2"
                onClick={() => setIsOpen(false)}
              >
                {t('nav.gallery')}
              </Link>
              <Link 
                to="/corso-osmand" 
                className="text-gray-700 hover:text-blue-600 font-medium py-2 flex items-center"
                onClick={() => setIsOpen(false)}
              >
                <GraduationCap size={18} className="mr-2" />
                {t('nav.corsoOsmand')}
              </Link>
              <Link 
                to="/about" 
                className="text-gray-700 hover:text-blue-600 font-medium py-2"
                onClick={() => setIsOpen(false)}
              >
                {t('nav.about')}
              </Link>
              <Link 
                to="/contact" 
                className="text-gray-700 hover:text-blue-600 font-medium py-2"
                onClick={() => setIsOpen(false)}
              >
                {t('nav.contact')}
              </Link>
              
              {/* Mobile Language Switcher with Flag Images */}
              <div className="flex items-center space-x-2 pt-3 border-t">
                {languages.map((lang) => (
                  <button
                    key={lang.code}
                    onClick={() => changeLang(lang.code)}
                    title={lang.name}
                    className={`p-1 rounded transition-all ${
                      i18n.language === lang.code
                        ? 'ring-2 ring-blue-500'
                        : 'opacity-70'
                    }`}
                  >
                    <img 
                      src={lang.flag} 
                      alt={lang.name}
                      className="w-8 h-6 object-cover rounded-sm"
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
